(function () {
    'use strict';
    var m = angular.module('common');
    m.factory('http', ["$http", "$q", "routeHelper", "$route", "slowdownHelper", "uuid", "autologinHelper", "$rootScope", function ($http, $q, routeHelper, $route, slowdownHelper, uuid, autologinHelper, $rootScope) {
        var HttpRequest = function (method, url) {
            this.data = {
                method: method,
                url: url,
                params: {},
                body: undefined,
                preFetches: [],
                converters: [],
                bodyConverters: [],
                pagination: undefined,
                filter: undefined,
                order: undefined,
                timeoutPromise: undefined,
                cache: undefined,
                showTotalRows: true,
                returnRawFirst: false,
                addUuid: false
            };
        };
        var count_400_errors = 0;
        HttpRequest.prototype.preFetch = function (promise, name) {
            this.data.preFetches.push({
                promise: promise,
                name: name
            });
            return this;
        };
        HttpRequest.prototype.params = function (params) {
            $.extend(true, this.data.params, _(params).chain().map(function (param, key) {
                if (_(param).isBoolean()) {
                    return [
                        key,
                        param ? 1 : 0
                    ];
                }
                return [
                    key,
                    param
                ];
            }).object().value());
            return this;
        };
        HttpRequest.prototype.body = function (body) {
            this.data.body = body;
            return this;
        };
        HttpRequest.prototype.onRequestFail = function (onFail) {
            this.data.onFail = onFail;
            return this;
        };
        HttpRequest.prototype.converter = function (converter, args) {
            if (_(converter).isUndefined()) {
                return this;
            }
            this.data.converters.push({
                converter: converter,
                args: args
            });
            return this;
        };
        HttpRequest.prototype.after = function (func) {
            if (_(func).isUndefined()) {
                return this;
            }
            this.data.converters.push({
                converter: function (input) {
                    func(input);
                    return $q.when(input);
                }
            });
            return this;
        };
        HttpRequest.prototype.bodyConverter = function (converter, args) {
            if (_(converter).isUndefined()) {
                return this;
            }
            this.data.bodyConverters.push({
                converter: converter,
                args: args
            });
            return this;
        };
        HttpRequest.prototype.dynamicConverter = function (converter, args) {
            this.data.converters.push({
                dynamicConverter: converter,
                args: args
            });
            return this;
        };
        HttpRequest.prototype.count = function () {
            this.data.count = true;
            return this;
        };
        HttpRequest.prototype.pagination = function (offset, limit) {
            this.data.pagination = {
                offset: offset,
                limit: limit
            };
            return this;
        };
        HttpRequest.prototype.filter = function (filter) {
            this.data.filter = filter;
            return this;
        };
        HttpRequest.prototype.order = function (column, direction, nulls) {
            this.data.order = {
                column: column,
                direction: direction,
                nulls: nulls
            };
            return this;
        };
        HttpRequest.prototype.showTotalRows = function (show) {
            this.data.showTotalRows = show;
            return this;
        };
        HttpRequest.prototype.returnRawFirst = function (raw) {
            this.data.returnRawFirst = raw;
            return this;
        };
        HttpRequest.prototype.timeout = function (timeoutPromise) {
            if (_(timeoutPromise).isUndefined()) {
                var deferred = $q.defer();
                this.data.timeoutPromise = deferred.promise;
                return deferred;
            }
            this.data.timeoutPromise = timeoutPromise;
            return this;
        };
        HttpRequest.prototype.cache = function (timeout, name) {
            this.data.cache = {
                timeout: timeout,
                name: name
            };
            return this;
        };
        HttpRequest.prototype.addUuid = function (addUuid) {
            if (_(addUuid).isUndefined()) {
                addUuid = true;
            }
            this.data.addUuid = addUuid;
            return this;
        };
        HttpRequest.prototype.run = function () {
            var deferred = $q.defer();
            this.then(function (response) {
                deferred.resolve(response);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };
        HttpRequest.prototype.ignore403Error = function (value) {
            this.data.ignore403Error = value;
            return this;
        };
        HttpRequest.prototype.then = function (callback, errorCallback) {
            callback = callback || _.noop;
            var originCallback = errorCallback || _.noop;
            errorCallback = function (error) {
                originCallback(error);
                if (error && $route.current.name != 'auth' && $route.current.name != 'authorize-error') {
                    if (error.status == 400 && error.message === 'CSRF token mismatch') {
                        count_400_errors++;
                        routeHelper.saveRoute();
                        if (count_400_errors > 4) {
                            count_400_errors = 0;
                            var logoutReason = autologinHelper.enabled() ? 'Portal Logout by HTTP 400 Error' : 'HTTP 400 Error';    // $rootScope.$broadcast('$logout', {
                                                                                                                                    //     reason: logoutReason
                                                                                                                                    // });
                        }
                    } else if (!self.data.ignore403Error && error.status == 403) {
                        if (count_400_errors > 0) {
                            count_400_errors--;
                        } else {
                            count_400_errors = 0;
                        }
                        var message = error && error.data && error.data.message;
                        if (message && message.includes('Insufficient privileges')) {
                            $rootScope.$broadcast('$unauthorized', {
                                reason: 'HTTP 403 Error',
                                message: message
                            });
                            return;
                        }
                        if (message && message.startsWith('Action failed!')) {
                            var errTitle = error && error.data && error.data.title;
                            $rootScope.$broadcast('$actionfailed', {
                                reason: 'HTTP 403 Error',
                                message: message,
                                title: errTitle
                            });
                            return;
                        }
                        routeHelper.saveRoute();
                        if (!autologinHelper.enabled()) {
                            $rootScope.$broadcast('$logout', { reason: 'HTTP 403 Error' });
                        }
                    } else {
                        if (count_400_errors > 0) {
                            count_400_errors--;
                        } else {
                            count_400_errors = 0;
                        }
                    }
                }
            };
            if (slowdownHelper.disableRequests()) {
                var disabledError = {
                    status: 500,
                    data: { message: 'Requests temporarily disabled' }
                };
                errorCallback(disabledError);
                return $q.reject(disabledError);
            }
            var self = this;
            function process(callback, errorCallback) {
                var deferred = $q.defer();
                var buildHttpPromise = self.data.buildHttpPromise = self.data.buildHttpPromise || _.memoize(function (url) {
                    if (self.data.method === 'local') {
                        return $q.when(url);
                    }
                    var methodParams = self.data.params;
                    if (!_(self.data.pagination).isUndefined()) {
                        methodParams.offset = self.data.pagination.offset;
                        methodParams.limit = self.data.pagination.limit;
                    }
                    if (!_(self.data.filter).isUndefined()) {
                        methodParams.filterBy = self.data.filter;
                    }
                    if (!_(self.data.order).isUndefined()) {
                        methodParams.sortColumn = self.data.order.column;
                        methodParams.sortDirection = self.data.order.direction;
                        methodParams.orderNulls = self.data.order.nulls;
                    }
                    if (self.data.count) {
                        methodParams.queryCount = 1;
                    }
                    if (self.data.showTotalRows === false) {
                        methodParams.disableTotalRows = 1;
                    }
                    if (self.data.returnRawFirst === true) {
                        methodParams.returnRawFirst = 1;
                    }
                    if (self.data.addUuid === true) {
                        methodParams.uuid = uuid.random();
                    }
                    if (self.data.method == 'get') {
                        return $http[self.data.method](url, {
                            timeout: self.data.timeoutPromise,
                            params: methodParams
                        });
                    }
                    return processConverter(self.data.bodyConverters, self.data.body).then(function (body) {
                        return $http[self.data.method](url, body, {
                            timeout: self.data.timeoutPromise,
                            params: methodParams
                        });
                    });
                });
                function processConverter(converters, input, preFetches, deferred, callback) {
                    var result = { promise: undefined };
                    if (_(deferred).isUndefined()) {
                        result = deferred = $q.defer();
                    }
                    if (!converters.length) {
                        if (_(callback).isFunction()) {
                            deferred.resolve(callback(input));
                        } else {
                            deferred.resolve(input);
                        }
                        return result.promise;
                    }
                    var c = _(converters).first();
                    var args = c.args || {};
                    if (_(args).isFunction()) {
                        args = args(preFetches);
                    }
                    args.http = self.data;
                    var converter = c.converter;
                    if (_(c.dynamicConverter).isFunction()) {
                        converter = c.dynamicConverter(preFetches);
                    }
                    if (_(converter).isUndefined()) {
                        processConverter(_(converters).rest(), input, preFetches, deferred, callback);
                    } else {
                        converter(input, args).then(function (result) {
                            processConverter(_(converters).rest(), result, preFetches, deferred, callback);
                        }, function (error) {
                            errorCallback(error);
                            deferred.reject(error);
                        });
                    }
                    return result.promise;
                }
                var requests = _(self.data.preFetches).map(function (preFetch) {
                    return preFetch.promise;
                });
                function buildPreFetches(preFetchResponses) {
                    var preFetches = {};
                    _(preFetchResponses).each(function (preFetch, idx) {
                        preFetches[self.data.preFetches[idx].name] = preFetch;
                    });
                    return preFetches;
                }
                function executeRequest(url, preFetchesPromise) {
                    return buildHttpPromise(url).then(function (httpResponse) {
                        preFetchesPromise.then(function (preFetches) {
                            processConverter(self.data.converters, httpResponse, preFetches, deferred, callback);
                        });
                    }, function (error) {
                        if (self.data.onFail) {
                            self.data.onFail(error).then(function (httpResponse) {
                                preFetchesPromise.then(function (preFetches) {
                                    processConverter(self.data.converters, httpResponse, preFetches, deferred, callback);
                                });
                            }, function (error) {
                                errorCallback(error);
                                deferred.reject(error);
                            });
                        } else {
                            errorCallback(error);
                            deferred.reject(error);
                        }
                    });
                }
                if (_(self.data.url).isFunction()) {
                    $q.all(requests).then(function (preFetchResponses) {
                        if (count_400_errors > 0) {
                            count_400_errors--;
                        } else {
                            count_400_errors = 0;
                        }
                        var preFetches = buildPreFetches(preFetchResponses);
                        executeRequest(self.data.url(preFetches), $q.when(preFetches));
                    }, function (error) {
                        errorCallback(error);
                        deferred.reject(error);
                    });
                } else {
                    var preFetchesDeferred = $q.defer();
                    $q.all(requests).then(function (preFetchResponses) {
                        if (count_400_errors > 0) {
                            count_400_errors--;
                        } else {
                            count_400_errors = 0;
                        }
                        var preFetches = buildPreFetches(preFetchResponses);
                        preFetchesDeferred.resolve(preFetches);
                    }, function (error) {
                        errorCallback(error);
                        deferred.reject(error);
                        preFetchesDeferred.reject(error);
                    });
                    executeRequest(self.data.url, preFetchesDeferred.promise);
                }
                return deferred.promise;
            }
            return process(callback, errorCallback);
        };
        function method(methodName) {
            return function (url) {
                return new HttpRequest(methodName, url);
            };
        }
        return {
            'get': method('get'),
            'put': method('put'),
            'post': method('post'),
            'delete': method('delete'),
            'patch': method('patch'),
            'local': method('local')
        };
    }]);
}());